module.exports = __webpack_public_path__ + "media/images/estacao_meteorologica_two-c7840d5b9ab9e3a519e0cae0e6ef07a7.png";